const secrets = {
    third_party_token_set: {
        token_not_found: '找不到憑證記錄。',
        access_token_expired: '訪問憑證已過期。請重新連接你的帳戶。',
    },
};
export default Object.freeze(secrets);
